
export type InvalidSaveDiscountResult = {
    successful: false
    errors: SaveDiscountResultError[],
}

export type SuccessfulSaveDiscountResult = {
    successful: true
    discountId: number
    idMap: {[id: string]: string}
}

export type SaveDiscountResult =
    InvalidSaveDiscountResult
    | SuccessfulSaveDiscountResult

export type SaveDiscountResultError = {
    category: SaveDiscountErrorCategory
    message: string
    categorySectionHint?: string
}

export enum SaveDiscountErrorCategory {
    General,
    BasicInfo,
    ApplicableProducts,
    Units,
    Schools,
    Dates,
    Countries,
    Agents,
    Action, 
    AdditionalCriteria,
    Divisions
}